import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import { fetchLabels } from '../utils/Label'
import { voiceStore } from '../stores/voiceStore'
import { observer } from 'mobx-react-lite'

const ContactPage = () => {
    const [labels , setLabels] = useState('')

    useEffect(() => {
        const fetchLabelsData = async () => {
            const updatedLabels = await fetchLabels();
            setLabels(updatedLabels)
        };
    
        fetchLabelsData();
    }, [sessionStorage.getItem("CommunicationLanguage"), voiceStore.language]);

    return (
        <>
            <div className="flex flex-col min-h-screen">
                <Header breadcrumbs="Customer App" labels={labels }/>
                <div className="flex-grow mx-4 mb-16 overflow-auto font-gotham-rounded">
                    <Contact  labels={labels }/>
                </div>
                <Footer className="fixed bottom-0 w-full bg-white" labels={labels }/>
            </div>
        </>
    )
}

export default observer(ContactPage)